import { render } from "./MsCheckbox.vue?vue&type=template&id=3ab52c84&scoped=true"
import script from "./MsCheckbox.vue?vue&type=script&lang=js"
export * from "./MsCheckbox.vue?vue&type=script&lang=js"

import "./MsCheckbox.vue?vue&type=style&index=0&id=3ab52c84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab52c84"]])

export default __exports__